<template>
  <section class="crypto">
    <div class="container">
      <div class="crypto-content">
        <p data-aos="fade-up" class="crypto-content-title">
          Receive and Sell Crypto With Ease 🚀
        </p>
        <div class="crypto-content-section">
          <div
            class="crypto-content-section-article"
            v-for="(crypto, index) in cryptos"
            :key="index"
          >
            <h2 data-aos="fade-up">{{ crypto.title }}</h2>
            <ul>
              <li
                data-aos="fade-up"
                data-aos-duration="1500"
                v-for="(desc, index) in crypto.desc"
                :key="index"
              >
                <img class="mark" src="/img/tick-circle.svg" />{{ desc }}
              </li>
            </ul>
            <img
              data-aos="fade-up"
              data-aos-anchor-placement="top-bottom"
              data-aos-delay="500"
              data-aos-offset="0"
              class="img"
              :src="`/img/${crypto.image}.svg`"
              alt="crypto"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      cryptos: [
        {
          title: "How To Receive Crypto",
          desc: [
            "Open the app and navigate to the crypto page.",
            "Choose the cryptocurrency you want to receive.",
            "Generate a wallet address.",
            "Send your crypto to the wallet address and receive the equivalent of your crypto in naira.",
            "If AutoSell is ON, your crypto automatically converts to Naira and is credited to your wallet. If OFF, your crypto stays in your crypto wallet until you choose to sell.",
          ],
          image: "receive-crypto",
        },
        {
          title: "How To Sell Crypto",
          desc: [
            "Open the app and navigate to the crypto page.",
            "View Your Stored Crypto assets.",
            "Select a Crypto to Sell.",
            "Enter the amount you want to sell, or choose 'Sell Max' to sell your entire balance.",
            "You then receive the equivalent amount of the crypto in Naira Instantly.",
          ],
          image: "sell-crypto",
        },
      ],
    };
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/scss/global.scss";

.crypto {
  background-color: $white;
  padding: 3rem 0;
  & .crypto-content {
    &-title {
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 1rem;

      @media screen and (min-width: 1000px) {
        font-size: 2rem;
        margin-bottom: 2rem;
      }
    }

    &-section {
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      gap: 2rem;

      @media screen and (min-width: 1000px) {
        grid-template-columns: repeat(2, 1fr);
      }

      &-article {
        padding: 28px 20px 0;
        background-color: #fafaff;
        border-radius: 8px;

        @media screen and (min-width: 1000px) {
          padding: 48px 40px 0;
          position: relative;
          padding-bottom: 40px;
          height: 950px;
        }

        @media screen and (min-width: 1200px) {
          height: 800px;
        }

        h2 {
          font-weight: 600;
          font-size: 20px;
          line-height: 30px;
          color: "#010137";
        }
        ul {
          margin-top: 1rem;
          li {
            display: flex;
            align-items: start;
            margin-top: 1rem;
            .mark {
              margin-right: 0.5rem;
              height: 24px;
              width: 24px;
            }
          }
        }

        .img {
          margin: 4rem auto 0;
          width: 100%;
          max-height: 100%;
          max-width: 415px;
          display: flex;
          align-items: center;

          @media screen and (min-width: 1000px) {
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            margin-top: 0;
            object-fit: contain;
          }
        }
      }
    }
  }
}
</style>
